// extracted by mini-css-extract-plugin
module.exports = {"table":"Checklist_table__erWBX"};